import axios from 'axios'
import { baseURL } from '@/config'
import { showToast } from 'vant';
import { useWork } from '@/stores/work'
const http = axios.create({
	baseURL: baseURL,
	timeout: 1000 * 30,
	withCredentials: true
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
	config.headers.Authorization = 'Bearer ' + useWork().auth.token;
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	if (response.data.code == 0) {
		return response.data.data;
	} else if (response.data.code == 401) {
		// console.log("token失效，尝试重新获取")
		// let refreshToken = sessionStorage.getItem("refreshToken");
		// if (!refreshToken) {
		// 	location.href = "/";
		// }
		// // 发送请求, 进行刷新token操作, 获取新的token
		// const data = await http({
		// 	method: 'put',
		// 	url: '/refreshToken',
		// 	headers: {
		// 		refreshToken: refreshToken
		// 	}
		// }).catch(() => {
		// 	location.href = "/";
		// })
		// // 保存token
		// sessionStorage.setItem("accessToken", data.accessToken);
		// sessionStorage.setItem("refreshToken", data.refreshToken);
		// // 重新发送刚才的请求
		// return http(response.config)
	} else {
		showToast(response.data.msg)
		return Promise.reject(response.data)
	}
}, error => {
	showToast('系统错误')
})

export const get = (url, params, config = {}) => {
	return http.get(url, { params, ...config });
};

// 封装 POST 请求
export const post = (url, data, config = {}) => {
	return http.post(url, data, config);
};
export const del = (url, params, config = {}) => {
	return http.delete(url, { params, ...config });
};
